import { render, staticRenderFns } from "./competencies.vue?vue&type=template&id=1bbc70a0&"
import script from "./competencies.vue?vue&type=script&lang=js&"
export * from "./competencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/competencies.vue
// module id = 1374
// module chunks = 0